/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/contact',
      load: () => import(/* webpackChunkName: 'contact' */ './contact'),
    },
    {
      path: '/the-science-behind-habits',
      load: () => import(/* webpackChunkName: 'the-science-behind-habits' */ './the-science-behind-habits'),
    },
    {
      path: '/a-system-for-changing-habits',
      load: () => import(/* webpackChunkName: 'a-system-for-changing-habits' */ './a-system-for-changing-habits'),
    },
    {
      path: '/tips-and-tricks',
      load: () => import(/* webpackChunkName: 'tips-and-tricks' */ './tips-and-tricks'),
    },
    {
      path: '/support',
      load: () => import(/* webpackChunkName: 'support' */ './support'),
    },
    {
      path: '/privacy-policy',
      load: () =>
        import(/* webpackChunkName: 'privacy-policy' */ './privacy-policy'),
    },
    {
      path: '/terms-of-use',
      load: () =>
        import(/* webpackChunkName: 'terms-of-use' */ './terms-of-use'),
    },

    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    let title = 'Habitual: Track habits, build routines and accomplish goals';
    if (route.title) title += ` · ${route.title}`;

    // Provide default values for title, description etc.
    route.title = title;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
